import type { CrossroadsCompany } from '../api/hooks/useCrossroadsNetwork'

export class CompanyMapper {
  private static instance: CompanyMapper
  private companyMap: Map<string, string> = new Map()
  private tenantToCompanyIdMap: Map<string, string> = new Map()

  private constructor() {}

  public static getInstance(): CompanyMapper {
    if (!CompanyMapper.instance) {
      CompanyMapper.instance = new CompanyMapper()
    }
    return CompanyMapper.instance
  }

  public setCompanies(companies: CrossroadsCompany[]): void {
    this.companyMap.clear()
    this.tenantToCompanyIdMap.clear()

    companies.forEach((company) => {
      if (company.name && company._id) {
        this.companyMap.set(company.name, company._id)
      }
      if (company.rita_tenant && company._id) {
        this.tenantToCompanyIdMap.set(company.rita_tenant, company._id)
      }
    })
  }

  public getCompanyIdByName(name: string): string | undefined {
    return this.companyMap.get(name)
  }

  public getCompanyIdByTenantName(tenantName: string): string | undefined {
    return this.tenantToCompanyIdMap.get(tenantName)
  }

  public getAllCompanies(): Map<string, string> {
    return new Map(this.companyMap)
  }

  public hasCompanies(): boolean {
    return this.companyMap.size > 0
  }

  public clear(): void {
    this.companyMap.clear()
    this.tenantToCompanyIdMap.clear()
  }
}
